// redux/actions/MATERIAS/types.js
export const FETCH_MATERIAS_SUCCESS = "FETCH_MATERIAS_SUCCESS";
export const FETCH_MATERIAS_FAILURE = "FETCH_MATERIAS_FAILURE";
